import { useEffect } from "react";

/**
 * The drawn buttons' line boil: a new drawing every 100ms, three of them, as
 * the animation beside them is drawn.
 *
 * It writes the `seed` attribute straight onto every `feTurbulence.boil` on the
 * page rather than holding it in state — re-rendering the tree ten times a
 * second to change one SVG attribute is work for nothing, and the attribute is
 * not something anything else reads.
 */
export function useBoil() {
  useEffect(() => {
    if (matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    let seed = 0;
    const id = setInterval(() => {
      seed = (seed + 1) % 3;
      document
        .querySelectorAll("feTurbulence.boil")
        .forEach((t) => t.setAttribute("seed", String(seed)));
    }, 100);
    return () => clearInterval(id);
  }, []);
}
